module.exports = __webpack_public_path__ + "img/ABSNSE-Log.95f19d5b.svg";